import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '../../../../utils/baseQueryWithReauth';
import { PriceListSearchParams, PriceListResponse } from '../types/types';

const basePriceListQuery = createBaseQueryWithReauth({
  baseUrl: process.env.REACT_APP_UAT_PRICE_LIST_API_URL || '',
});

export const priceListApiSlice = createApi({
  reducerPath: 'priceListApi',
  baseQuery: basePriceListQuery,
  endpoints: (builder) => ({
    getPriceList: builder.query<PriceListResponse, PriceListSearchParams>({
      query: (params) => {
        return {
          url: `/Search/PriceListName/${encodeURIComponent(params.priceListName)}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetPriceListQuery,
  useLazyGetPriceListQuery,
} = priceListApiSlice; 